import { useState, useEffect } from 'react';
import { X, Sparkles } from 'lucide-react';

export const NewYearBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Check if banner was dismissed in this session
    const dismissed = sessionStorage.getItem('newyear_banner_dismissed');
    if (dismissed) {
      setIsDismissed(true);
      return;
    }

    // Show only on January 1-2 (any year)
    const now = new Date();
    const month = now.getMonth(); // 0 = January
    const day = now.getDate();
    
    // Show on Jan 1 and Jan 2
    if (month === 0 && (day === 1 || day === 2)) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    setIsDismissed(true);
    sessionStorage.setItem('newyear_banner_dismissed', 'true');
  };

  if (!isVisible || isDismissed) {
    return null;
  }

  return (
    <div className="relative overflow-hidden bg-gradient-to-r from-purple-600 via-pink-500 to-orange-400 text-white py-3 px-4">
      {/* Animated sparkles background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1 left-[10%] animate-pulse">✨</div>
        <div className="absolute top-2 left-[30%] animate-pulse delay-100">🎆</div>
        <div className="absolute top-1 left-[50%] animate-pulse delay-200">✨</div>
        <div className="absolute top-2 left-[70%] animate-pulse delay-300">🎇</div>
        <div className="absolute top-1 left-[90%] animate-pulse delay-100">✨</div>
      </div>
      
      <div className="container mx-auto flex items-center justify-center gap-3 relative z-10">
        <Sparkles className="h-5 w-5 animate-pulse" />
        <p className="text-center font-semibold text-sm md:text-base">
          🎉 Happy New Year 2025! Wishing you a secure and spam-free inbox! 🎊
        </p>
        <Sparkles className="h-5 w-5 animate-pulse" />
        
        <button
          onClick={handleDismiss}
          className="absolute right-2 top-1/2 -translate-y-1/2 p-1 hover:bg-white/20 rounded-full transition-colors"
          aria-label="Dismiss banner"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
